import { lazy } from 'react'
import { RouteConfig } from 'react-router-config'
import { Redirect } from 'react-router-dom'

const ReservationV2Layout = lazy(
  () => import('@/pages/hmt/reservation-v2/layout')
)

const ReservationV2Routes: RouteConfig[] = [
  {
    path: '/pc-site/reservation',
    component: ReservationV2Layout,
    routes: [
      {
        path: '/pc-site/reservation',
        exact: true,
        render: () => <Redirect to="/pc-site/reservation/home" />,
      },
      {
        path: '/pc-site/reservation/home/:userId?',
        component: lazy(() => import('@/pages/hmt/reservation-v2/pc-site')),
      },
    ],
  },
  {
    path: '/m-site/reservation',
    component: ReservationV2Layout,
    routes: [
      {
        path: '/m-site/reservation',
        exact: true,
        render: () => <Redirect to="/m-site/reservation/home" />,
      },
      {
        path: '/m-site/reservation/home/:userId?',
        component: lazy(() => import('@/pages/hmt/reservation-v2/m-site')),
      },
    ],
  },
]

export default ReservationV2Routes
